// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"SectionF_TheComp__F8qYL"};